import { createIcon } from '@chakra-ui/react'

export const CircleIcon = createIcon({
  displayName: 'CircularGraphIcon',
  path: <circle fill='currentColor' cx='9' cy='9' r='9' />,
  viewBox: '0 0 18 18',
})
